// Import all of Bootstrap's JS
import * as bootstrap from "bootstrap";

(($, Drupal) => {
  const pageScroll = (context) => {
    let lastScrollPosition = 0;
    let ticking = false;

    // Scroll event listener
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const body = document.body;
          body.classList.toggle("scrolled", scrollTop > 50);
          body.classList.toggle("scrolldown", scrollTop > lastScrollPosition);
          body.classList.toggle("scrollup", scrollTop < lastScrollPosition);
          lastScrollPosition = scrollTop;
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener("scroll", handleScroll);
  };

  Drupal.behaviors.dialogPatch = {
    attach(context, settings) {
      // Patch jQuery UI dialog to prevent errors on uninitialized dialogs
      var originalDialog = $.fn.dialog;
      $.fn.dialog = function (method) {
        // If called as a method (string), verify initialization before proceeding
        if (typeof method === "string" && !this.data("ui-dialog")) {
          // Dialog not initialized, ignore method call
          return this;
        }
        return originalDialog.apply(this, arguments);
      };
    },
  };

  Drupal.behaviors.bootstrapToastInit = {
    attach: (context) => {
      const toastElements = context.querySelectorAll(".toast");
      toastElements.forEach((toastElement) => {
        const toast = new bootstrap.Toast(toastElement);
        toast.show();
      });
    },
  };

  Drupal.behaviors.bootstrapTooltipInit = {
    attach: (context) => {
      const tooltipTriggerList = context.querySelectorAll("[data-drupal-tooltip]");
      tooltipTriggerList.forEach((tooltipTriggerEl) => {
        new bootstrap.Tooltip(tooltipTriggerEl, {
          title: tooltipTriggerEl.getAttribute("data-drupal-tooltip"),
        });
      });
    },
  };

  Drupal.behaviors.bootstrapBarrioSubtheme = {
    attach(context) {
      pageScroll(context);
    },
  };
})(jQuery, Drupal);
